// extracted by mini-css-extract-plugin
export default {"channelsContainer":"CSIV5SjuxwwZlO2Jha9M","right":"b7JpZcSc5FosOOgCKIgg","left":"HtFIPwOTuDX6cRrfm4An"};